let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9CDY0"), load("joJy8"), load("aHE9G"), load("dQy5b")]).then(() => parcelRequire('fcgkZ'));